import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const InfoGridValue: FunctionComponent<Props> = ({ isEmpty = false, testId = TEST_ID, value }) => (
    <div
        className={`${styles.infoGridValue}${isEmpty ? ` ${styles.empty}` : ''}`}
        data-testid={testId}
    >
        {value}
    </div>
);

export default InfoGridValue;
